<script setup>
/* eslint-disable vue/no-bare-strings-in-template */
import { computed } from 'vue';
import wootConstants from 'dashboard/constants/globals';
import ReportCard from '../ReportCard.vue';

const props = defineProps({
  noOfBreachesByEvent: {
    type: Object,
    default: () => ({}),
  },
  hitRate: {
    type: String,
    required: true,
  },
  noOfBreaches: {
    type: Number,
    required: true,
  },
  noOfConversations: {
    type: Number,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const { SLA_MISS_TYPES } = wootConstants;
const hitRateValue = computed(() => Number.parseFloat(props.hitRate) || 0);
const eventRows = computed(() => [
  {
    key: SLA_MISS_TYPES.FRT,
    label: 'Primeira resposta',
    value: props.noOfBreachesByEvent?.[SLA_MISS_TYPES.FRT] || 0,
    color: 'bg-red-500',
  },
  {
    key: SLA_MISS_TYPES.NRT,
    label: 'Próxima resposta',
    value: props.noOfBreachesByEvent?.[SLA_MISS_TYPES.NRT] || 0,
    color: 'bg-amber-500',
  },
  {
    key: SLA_MISS_TYPES.RT,
    label: 'Resolução',
    value: props.noOfBreachesByEvent?.[SLA_MISS_TYPES.RT] || 0,
    color: 'bg-violet-500',
  },
]);
const maxEventValue = computed(() =>
  Math.max(...eventRows.value.map(row => row.value), 1)
);
</script>

<template>
  <div class="grid grid-cols-1 gap-4 xl:grid-cols-12">
    <ReportCard
      class="xl:col-span-3 dark:!bg-slate-900 dark:!border-slate-700/50"
      :is-loading="isLoading"
    >
      <p class="mb-2 text-sm text-slate-500 dark:text-slate-400">
        Taxa de cumprimento
      </p>
      <strong class="text-4xl text-green-600 dark:text-green-400">
        {{ hitRate }}
      </strong>
      <div
        class="h-2 mt-5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-700"
      >
        <div
          class="h-full bg-green-500 rounded-full"
          :style="{ width: `${Math.min(hitRateValue, 100)}%` }"
        />
      </div>
    </ReportCard>

    <ReportCard
      class="xl:col-span-2 dark:!bg-slate-900 dark:!border-slate-700/50"
      :is-loading="isLoading"
    >
      <p class="mb-2 text-sm text-slate-500 dark:text-slate-400">Conversas</p>
      <strong class="text-4xl text-slate-900 dark:text-slate-50">
        {{ noOfConversations }}
      </strong>
      <p class="mt-3 mb-0 text-sm text-slate-500 dark:text-slate-400">
        Avaliadas pelas políticas de SLA
      </p>
    </ReportCard>

    <ReportCard
      class="xl:col-span-2 dark:!bg-slate-900 dark:!border-slate-700/50"
      :is-loading="isLoading"
    >
      <p class="mb-2 text-sm text-slate-500 dark:text-slate-400">Violações</p>
      <strong class="text-4xl text-red-600 dark:text-red-400">
        {{ noOfBreaches }}
      </strong>
      <p class="mt-3 mb-0 text-sm text-slate-500 dark:text-slate-400">
        Metas não cumpridas no período
      </p>
    </ReportCard>

    <ReportCard
      class="xl:col-span-5 dark:!bg-slate-900 dark:!border-slate-700/50"
      :is-loading="isLoading"
    >
      <h3 class="mb-4 text-lg font-medium text-slate-900 dark:text-slate-50">
        Violações por tipo de evento
      </h3>
      <div class="space-y-4">
        <div
          v-for="row in eventRows"
          :key="row.key"
          class="grid grid-cols-[9rem_1fr_2rem] items-center gap-3 text-sm"
        >
          <span class="text-slate-600 dark:text-slate-300">{{
            row.label
          }}</span>
          <span
            class="h-2 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-700"
          >
            <span
              class="block h-full rounded-full"
              :class="row.color"
              :style="{ width: `${(row.value / maxEventValue) * 100}%` }"
            />
          </span>
          <strong class="text-right text-slate-800 dark:text-slate-100">{{
            row.value
          }}</strong>
        </div>
      </div>
    </ReportCard>
  </div>
</template>
